/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from 'react'
import './layout.css'
import AuthContextProvider from '../context/authContext'
import { ToastProvider } from '../context/toastContext'
import Toast from '../components/toast/Toast'
import Header from '../components/header/header'

const Layout = ({ children }) => {
  return (
    <ToastProvider>
      <AuthContextProvider>
        <Toast />
        <Header />
        <div
          className="min-vh-100 bg-dark text-light"
          style={{
            height: '100vh',
            backgroundColor: '#0f0f0f',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
          }}
        >
          {children}
        </div>
      </AuthContextProvider>
    </ToastProvider>
  )
}

export default Layout
